export default function AttendanceInfo() {
  return (
    <div style={styles.wrap}>
      <div style={styles.title}>Attendance</div>
      <div style={styles.text}>
        Check in members, add visitor counts, and save weekly attendance from the Church app screen.
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    padding: 6,
  },
  title: {
    color: "#0f172a",
    fontSize: 18,
    fontWeight: 800,
  },
  text: {
    color: "#475569",
    fontSize: 14,
    lineHeight: 1.6,
  },
};
